// Writes text whose production is asynchronous (server-side paging of a whole window)
// without losing the click's user activation: a plain `await …; clipboard.writeText()`
// runs after the transient activation has lapsed and silently rejects (NotAllowedError).
// ClipboardItem accepts a Promise, so the browser starts the write within the gesture
// and resolves the text once it is ready. Browsers without ClipboardItem fall back to
// writeText, where the activation window is the only protection.
export async function writeClipboardText(text: Promise<string>): Promise<void> {
  if (typeof ClipboardItem === 'undefined') {
    await navigator.clipboard.writeText(await text);
    return;
  }
  const blob = text.then(tsv => new Blob([tsv], { type: 'text/plain' }));
  await navigator.clipboard.write([new ClipboardItem({ 'text/plain': blob })]);
}
